import React from 'react'
import PropTypes from "prop-types";
import { AskAnExpertAlert } from "./AskAnExpertAlert";

export const AskAnExpertTextArea = (props) => {

  const {
    label,
    name,
    value,
    onChange,
    rows,
    placeholder,
    length,
    maxLength = 2000,
    isRequired = false,
    error = null
  } = props;

  if (isRequired === true) {
    //If required and less than 2000
    return (
      <div className="form-group">
        <label>{label} <span className="color-red">*</span></label>
        <br />
        <textarea className="form-control" rows={rows} name={name} value={value} onChange={onChange} placeholder={placeholder} required maxLength={maxLength}/>
        <div>
          <small className="float-right font-italic">{length}/{maxLength} characters</small>
        </div>
        {error !== null ? <AskAnExpertAlert message={error}/> : null}
      </div>
    )
  } else {
    return (
      <div className="form-group">
        <label>{label}</label>
        <br />
        <small>Length: {length} (max {maxLength})</small>
        <textarea className="form-control" rows={rows} name={name} value={value} onChange={onChange} placeholder={placeholder} maxLength={maxLength} />
        {error !== null ? <AskAnExpertAlert message={error}/> : null}
      </div>
    )
  }
}

AskAnExpertTextArea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  length: PropTypes.number,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  isRequired: PropTypes.bool,
  error: PropTypes.string
}



// WEBPACK FOOTER //
// src/client/components/site/features/askanexpert/form/AskAnExpertTextArea.js